import { ActiveLocation } from "..";

const localesSupportGroupTabGratuity = ["en-US"];

export const getIsGroupTabGratuitySupported = (activeLocation: ActiveLocation) =>
    localesSupportGroupTabGratuity.includes(activeLocation.locale);
